import { Link } from "react-router-dom";
import { Mail, Globe, MapPin, Linkedin, Phone } from "lucide-react";

const QUICK = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Team", to: "/team" },
  { label: "What We Do", to: "/what-we-do" },
  { label: "Products", to: "/products" },
  { label: "Methodology", to: "/methodology" },
  { label: "Why OpsIQ", to: "/why-opsiq" },
  { label: "Book Consultation", to: "/book" },
];

const SOLUTIONS = [
  "Executive Dashboards", "Finance Intelligence", "Operations Intelligence",
  "Sales Intelligence", "HR Intelligence", "Customer Intelligence",
  "Compliance Intelligence", "Business Reporting", "Performance Scorecards",
];

const INDUSTRIES = [
  "Financial Services", "SMEs", "Startups", "Agriculture", "Restaurants",
  "Hotels", "Retail", "Healthcare", "Education", "Government", "NGOs",
  "Manufacturing", "Professional Services",
];

export default function OpsFooter() {
  return (
    <footer data-testid="ops-footer" className="relative bg-[#08131F] text-[#F1ECE0] border-t border-white/10 overflow-hidden">
      <div className="absolute inset-0 ops-grid-bg opacity-30 pointer-events-none" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 pt-20 md:pt-24 pb-10">
        {/* Wordmark + tagline */}
        <div className="border-b border-white/10 pb-10 md:pb-14 mb-12 md:mb-16">
          <img
            src="/opsiq-logo-primary.png"
            alt="OpsIQ"
            className="h-14 md:h-20 w-auto object-contain"
            style={{ filter: "brightness(0) invert(1) opacity(0.96)" }}
          />
          <div className="mt-4 md:mt-6 font-editorial italic text-2xl md:text-3xl text-[#F1ECE0]/85">
            Know your business. <span className="text-[#D9FF3C]">Lead with confidence.</span>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-6 lg:grid-cols-12 gap-8 md:gap-10">
          {/* About column */}
          <div className="col-span-2 md:col-span-6 lg:col-span-3">
            <div className="text-[10px] font-plex-mono uppercase tracking-[0.22em] font-semibold text-[#D9FF3C] mb-5">
              Let&apos;s talk
            </div>
            <div className="flex flex-col gap-3">
              <a href="mailto:info@OpsIQ.live" data-testid="footer-email" className="inline-flex items-center gap-2 text-sm text-[#F1ECE0]/85 hover:text-[#D9FF3C] transition-colors">
                <Mail size={14} /> info@OpsIQ.live
              </a>
              <a href="https://www.opsiq.live" data-testid="footer-web" className="inline-flex items-center gap-2 text-sm text-[#F1ECE0]/85 hover:text-[#D9FF3C] transition-colors">
                <Globe size={14} /> www.OpsIQ.live
              </a>
              <a href="tel:+233546080065" data-testid="footer-phone" className="inline-flex items-center gap-2 text-sm text-[#F1ECE0]/85 hover:text-[#D9FF3C] transition-colors">
                <Phone size={14} /> +233 546 080 065
              </a>
              <span className="inline-flex items-center gap-2 text-sm text-[#F1ECE0]/85">
                <MapPin size={14} /> Accra, Ghana
              </span>
              <a href="#" data-testid="footer-linkedin" className="inline-flex items-center gap-2 text-sm text-[#F1ECE0]/85 hover:text-[#D9FF3C] transition-colors">
                <Linkedin size={14} /> LinkedIn / OpsIQ
              </a>
            </div>
          </div>

          <div className="col-span-1 md:col-span-2 lg:col-span-2">
            <div className="text-[10px] font-plex-mono uppercase tracking-[0.22em] font-semibold text-[#D9FF3C] mb-5">Quick links</div>
            <ul className="space-y-2.5">
              {QUICK.map((q) => (
                <li key={q.to}>
                  <Link to={q.to} data-testid={`fq-${q.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-sm text-[#F1ECE0]/75 hover:text-[#F1ECE0] transition-colors">
                    {q.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-1 md:col-span-2 lg:col-span-3">
            <div className="text-[10px] font-plex-mono uppercase tracking-[0.22em] font-semibold text-[#D9FF3C] mb-5">Solutions</div>
            <ul className="space-y-2.5">
              {SOLUTIONS.map((s) => (
                <li key={s}>
                  <Link to="/solutions" className="text-sm text-[#F1ECE0]/75 hover:text-[#F1ECE0] transition-colors">{s}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-1 md:col-span-2 lg:col-span-2">
            <div className="text-[10px] font-plex-mono uppercase tracking-[0.22em] font-semibold text-[#D9FF3C] mb-5">Industries</div>
            <ul className="space-y-2.5">
              {INDUSTRIES.map((s) => (
                <li key={s}>
                  <Link to="/industries" className="text-sm text-[#F1ECE0]/75 hover:text-[#F1ECE0] transition-colors">{s}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[10px] font-plex-mono uppercase tracking-[0.22em] text-[#F1ECE0]/45">
          <div>© {new Date().getFullYear()} OpsIQ · Accra, Ghana · All rights reserved.</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-[#F1ECE0]">Privacy</a>
            <a href="#" className="hover:text-[#F1ECE0]">Terms</a>
            <a href="#" className="hover:text-[#F1ECE0]">Imprint</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
